import { _js } from '@ifixit/localize';
import { OrderPartApiButton } from '../THD/thdApiButtons';
import { fromWiki } from '../Generic/fromWiki';
import { iFixitHotSpotItem } from '../Generic/iFixitHotSpotItem';
import { Button, ButtonProps, Link } from '@chakra-ui/react';

const OrderPartButton = ({
   data,
   ...props
}: {
   data: iFixitHotSpotItem;
} & ButtonProps) => {
   const isIfixitPart = fromWiki(data, 'isIfixitPart') || false;
   const sku = fromWiki(data, 'sku');

   if (!sku) {
      return null;
   }
   const apiButton = <OrderPartApiButton data={data} {...props} />;

   if (apiButton) {
      return apiButton;
   }

   if (isIfixitPart) {
      /**
       * When swapping to our stores on the same frontend, we swapped from carts being on iFixit
       * to carts being controlled by Shopify. We did not update this call site.
       *
       * The main thing seems to be that we need the CartLineItem, not just the sku.
       * Here is a pull with most of the implementation needed
       *
       * https://github.com/iFixit/ifixit/pull/54952
       */
      const addToCartWorksInSchematics = false;
      return addToCartWorksInSchematics ? <AddToCartButton data={data} {...props} /> : null;
   }

   return null;
};

const AddToCartButton = ({
   data,
   ...props
}: {
   data: iFixitHotSpotItem;
} & ButtonProps) => {
   const addToCart = () => {
      if (!data.wiki || !data.wiki.sku) {
         return;
      }

      const _quantity = 1;
      const _itemcode = data.wiki.sku;
      // addItemcode(itemcode, quantity);
   };

   return (
      <Button variant="cta" margin="16px 0px 10px" onClick={addToCart} {...props}>
         {_js('Order Part')}
      </Button>
   );
};

const ViewGuidesButton = ({ data, ...props }: { data: iFixitHotSpotItem } & ButtonProps) => {
   const hasWikiUrl = !!fromWiki(data, 'url');
   const hasGuides = !!fromWiki(data, 'hasAssociatedGuides');

   const showButton = hasWikiUrl && hasGuides;

   if (!showButton) {
      return null;
   }

   return (
      <Button
         as={Link}
         // @ts-expect-error TS(2531) FIXME: Object is possibly 'null'.
         href={data.wiki.url}
         isExternal={true}
         variant="outline"
         colorScheme="gray"
         {...props}
      >
         {_js('View Guides')}
      </Button>
   );
};

export { ViewGuidesButton, OrderPartButton };
